
import { Component, Vue } from "vue-property-decorator";
import { etablissementService } from "@/core/service/licencesnationales/EtablissementService";
import { iPService } from "@/core/service/licencesnationales/IPService";
import MessageBox from "@/components/common/MessageBox.vue";
import Etablissement from "@/core/Etablissement";
import { Message, MessageType } from "@/core/CommonDefinition";

@Component({
  components: { MessageBox }
})
export default class Historique extends Vue {
  etabs: Array<Etablissement> = [];
  message: string = "";
  select: string = "";
  etabHisto: Array<any> = [];
  ipHisto: Array<any> = [];

  mounted() {
    this.collecterEtab();
  }

  collecterEtab(): void {
    this.$store.dispatch("closeDisplayedMessage");
    etablissementService
      .getEtablissements(this.$store.getters.getToken())
      .then(response => {
        this.etabs = response;
      })
      .catch(err => {
        const message: Message = new Message();
        message.type = MessageType.ERREUR;
        message.texte = "Impossible d'exécuter l'action : " + err.message;
        message.isSticky = true;
        this.$store.dispatch("openDisplayedMessage", message);
      });
  }

  getHistorique(siren: string): void {
    etablissementService
      .getHisto(siren, this.$store.getters.getToken())
      .then(response => {
        this.etabHisto = response.data;
      })
      .catch(err => {
        const message: Message = new Message();
        message.type = MessageType.ERREUR;
        message.texte = err.message;
        message.isSticky = true;
        this.$store.dispatch("openDisplayedMessage", message);
      });

    iPService
      .getHisto(siren, this.$store.getters.getToken())
      .then(response => {
        this.ipHisto = response.data;
      })
      .catch(err => {
        const message: Message = new Message();
        message.type = MessageType.ERREUR;
        message.texte = err.message;
        message.isSticky = true;
        this.$store.dispatch("openDisplayedMessage", message);
      });
  }
}
